<script>
export const groupId = 'group-' + Math.random().toString(36).substring(2, 15)
</script>

<script setup>
const props = defineProps({
  item: Array,
})

const firstItemComponent = computed(() => props.item[0]) // Ignore other items, only render the first one. Avoids overlapping items.
</script>

<template>
  <div class="size-full relative">
    <div class="absolute bottom-0 w-full px-24 pb-36">
      <component :is="firstItemComponent.component" v-if="firstItemComponent" :key="firstItemComponent.key" :item="firstItemComponent.item" />
    </div>
  </div>
</template>
